import type { ReactNode } from 'react';

import { TONE_COLOR, type StatusTone } from '@/components/ri/statusTones';

export interface TabBadgeProps {
  children: ReactNode;
  tone?: StatusTone;
}

export function TabBadge({ children, tone = 'danger' }: TabBadgeProps) {
  const t = TONE_COLOR[tone];
  return (
    <span
      style={{
        position: 'absolute',
        top: -2,
        right: -8,
        minWidth: 16,
        height: 16,
        padding: '0 4px',
        borderRadius: 999,
        background: t.dot,
        color: '#fff',
        fontSize: 10,
        fontWeight: 600,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        border: '2px solid var(--surface-raised)',
        fontFamily: 'var(--font-mono)',
      }}
    >
      {children}
    </span>
  );
}
